import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Badge, Card, Row, Col } from 'react-bootstrap';
import { BiDoughnutChart } from 'react-icons/bi';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { MdFilterNone } from 'react-icons/md';
import { commafy } from 'Utils';
import TableEntitySunburst from './TableEntitySunburst';

const TableEntityCard = (props) => {
  const [constraints, setConstraints] = useState([]);

  useEffect(() => {
    try {
      if (
        props.filteredByCol && 
        props.data && 
        props.data.children
      ) {
        const column = props.data.children[0];

        if (column && column.constraints) {
          const constraintsValue = [];
          const constraints = column.constraints;

          for (let i = 0; i < constraints.length; i++) {
            constraintsValue.push(constraints[i].CONSTRAINT_NAME);
          }

          setConstraints(constraintsValue);
        } else {
          setConstraints([]);
        }
      }
    } catch(e) {
      console.log(e);
    }
  }, [props.filteredByCol]);

  return (
    <Card className="shadow-sm widget-card h-100 text-left">
      <div className="widget-header p-3">
        {!props.filteredByCol ? (
          <span>
            <BiDoughnutChart className="mr-2 widget-header-icon" /> 
            <span className='text-capitalize'>{props.dataLabel}</span> data
          </span>
        ) : (
          <span>
            <BiDoughnutChart className="mr-2 widget-header-icon" /> 
            Field data
          </span>
        )}
        {/* {(props.entity !== 'ALL' || props.filteredByCol !== null) && (
          <Link to={`/results/${props.searchid}/ALL/${props.table}`}>
            <Button 
              className="primary-corner-btn pr-3 pl-3 float-right m-0" 
              onClick={() => props.filterDataHandler(null)}
              size="sm"
            >
              <MdFilterNone className="mr-2" />
              View All
            </Button>
          </Link>
        )} */}
      </div>
      <Card.Body className='pt-0'>
        <Row>
          <Col className="text-center">
            <Row className="mb-1">
              <Col className="data-source-label">
                { props.entity === 'ALL' ? 'Total Findings' : props.entity }
              </Col>
            </Row>
            <Row>
              <Col>
                <h5>
                  { props.entity === 'ALL' ?
                    commafy(props.total) :
                    commafy(
                      props.filteredByCol
                        ? (props.filteredOverview[props.entity] || 0)
                        : (props.filteredEntityTotal ?? props.filteredOverview[props.entity] ?? 0)
                    )
                  }
                </h5>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="constraints-row">
            { props.filteredByCol && constraints.length > 0 ? (
              constraints.map((item, index) => 
                <Badge 
                  key={index} 
                  className="constraints-badge-sm mr-2"
                >
                  {item}
                </Badge>
              )
            ) : (
              <div className="entity-other-label text-center">
                <AiOutlineInfoCircle className="mr-1" />
                Identified entities in {' '}
                { props.data && 
                  props.data.children && 
                  props.data.children.filter((item) => item.children.length > 0).length
                } fields.
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-center">
            <TableEntitySunburst
              filteredByCol={props.filteredByCol}
              details={props.details}
              label={props.label}
              data={props.data}
              filterDataHandler={(v) => props.filterDataHandler(v)}
              search={props.searchid}
              table={props.table}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default TableEntityCard;